import { Model } from "pinia-orm";
import { BusinessPartnerCategoryEnum } from "@socotec.io/apollo-sync-back-sdk";

export default class User extends Model {
  static entity = "users";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.string(""),
      username: this.string(""),
      email: this.string(""),
      firstName: this.string(""),
      lastName: this.string(""),
      telephoneNumber: this.string(""),
      groups: this.attr([]),
      isCurrentUser: this.boolean(false),
      usermanagementUuid: this.attr(null),
      agencyCode: this.attr(null),
      umAgencyUuid: this.attr(null),
      umAgencyGroupUuid: this.attr(null),
      umSocietyUuid: this.attr(null),
    };
  }
  isCSP() {
    return this.groups.includes("CSPUser");
  }
  isAchat() {
    return this.groups.includes("AchatUser");
  }
  isValidator() {
    return this.isCSP() || this.isAchat();
  }
  isBasicUser() {
    return !this.isValidator();
  }
  getValidatorCategory() {
    const categories = [];
    if (this.isCSP()) {
      categories.push(BusinessPartnerCategoryEnum.Cli);
    }
    if (this.isAchat()) {
      categories.push(BusinessPartnerCategoryEnum.Fou);
    }
    return categories;
  }
}
